import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";



const ListArthikSakhaOfThisUser = () => {

  const handleRedirect = () => {
    navigate("/createfranchise");
  }


  const [franchises, setFranchises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const franchisesPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { auth } = useAuth();
  // const [selectedArthikSakhaId, setSelectedArthikSakhaId] = useState();
  const [selectedArthikSakhaId, setSelectedArthikSakhaId] = useState(auth?.level_id); // default value

  useEffect(() => {
    if (auth?.level_id) {
      setSelectedArthikSakhaId(auth.level_id);

    }
  }, [auth]);



  const fetchUserArthikSakhas = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-user-arthik-sakhas`, {
        withCredentials: true,
      });
      const franchiseList = response.data;
      setFranchises(franchiseList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Vibhags:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No Vibhags available.");
      setLoading(false);
    }
  }, [axiosPrivate]); // 👈 dependency added




  const handleViewClick = (franchiseId) => {
    // Navigate to the GetFranchise component with franchiseId as a URL parameter
    navigate(`/GetFranchise/${franchiseId}`);
  };
  const handleEditClick = (franchiseId) => {
    navigate(`/UpdateFranchise/${franchiseId}`);
  };


  useEffect(() => {
    fetchUserArthikSakhas();
  }, [selectedArthikSakhaId]);


  const indexOfLastFranchise = currentPage * franchisesPerPage;
  const indexOfFirstFranchise = indexOfLastFranchise - franchisesPerPage;
  const currentFranchise = franchises.slice(indexOfFirstFranchise, indexOfLastFranchise);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(franchises.length / franchisesPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
          <h3>Arthiksakhas under {auth?.name}</h3>

          <div className="table-container">
            <table id="customers">
              <thead>
                <tr>
                  <th>Arthiksakha</th>
                  <th>Jilla name</th>
                  <th>Amount</th>

                  <th>Options</th>
                </tr>
              </thead>

              <tbody>
                {error ? (
                  <tr>
                    <td colSpan="6" className="text-danger text-center">
                      {error}
                    </td>
                  </tr>
                ) : franchises.length === 0 ? (
                  <tr>
                    <td colSpan="6">No Data available.</td>
                  </tr>
                ) : (
                  currentFranchise.map(franchise => (
                    <tr key={franchise.arthik_sakha_id}>
                      <td>{franchise.arthik_sakha}</td>
                      <td>{franchise.jilla_name}</td>
                      <td>{franchise.amount}</td>
                      <td>
                        <button type="button" className="btn btn-warning btn-ico" onClick={() => handleEditClick(franchise.franchise_id)}>
                          <i className="bx bxs-edit icon"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>


            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
            </div>
          )}
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListArthikSakhaOfThisUser;